import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CloseComponent } from '../shared/components';
import { TitleComponent } from '@app/shared/components';
import { TranslatePipe } from '@ngx-translate/core';
import { AddComponent } from '@app/admin/students/add/add.component';

@Component({
    selector: 'app-add-student',
    imports: [TranslatePipe, RouterModule, TitleComponent, CloseComponent, AddComponent],
    templateUrl: './add-student.component.html',
    styleUrl: './add-student.component.css',
})
export class AddStudentComponent {}
